import React, { useEffect, useState } from "react";
import { RefreshCw, Sparkles } from "lucide-react";

/* New build detected → banner; tap to refresh (auto-applies silently when the app goes to background). */
export const UpdateBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => {
      setShow(true);
      // apply silently when the app goes to background (never mid-typing) — the open session stops showing the old UI
      const bg = () => { if (document.visibilityState === "hidden") { window.__pwaReloadOnControl = true; window.location.reload(); } };
      document.addEventListener("visibilitychange", bg);
    };
    window.addEventListener("pwa-update-available", on);
    return () => window.removeEventListener("pwa-update-available", on);
  }, []);
  const apply = () => { window.__pwaReloadOnControl = true; window.location.reload(); };
  if (!show) return null;
  return (
    <div className="fixed left-3 right-3 bottom-20 z-[90] rounded-2xl bg-slate-900 text-white shadow-2xl p-3 flex items-center gap-3 animate-in" data-testid="update-banner">
      <Sparkles className="w-5 h-5 text-amber-300 shrink-0" />
      <div className="flex-1 min-w-0"><div className="text-sm font-bold">புதிய update வந்துருக்கு · New version</div><div className="text-[11px] text-slate-300">Refresh tap பண்ணுங்க · அல்லது app-ஐ background-ல போட்டா தானா update ஆகும்</div></div>
      <button onClick={apply} className="rl-gold-bg px-3 py-2 rounded-xl text-xs font-black flex items-center gap-1 shrink-0" data-testid="update-banner-refresh"><RefreshCw className="w-3.5 h-3.5" />Refresh</button>
    </div>
  );
};
